module.exports = __webpack_public_path__ + "static/pemalex_img_main_h-c2db47e6d4154c1f0537551fd2019151.jpg";